import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgLock(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path fill="currentColor" d="M14.75 23.25L14.75 17.75H17.25L17.25 23.25L14.75 23.25Z" />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M16 1.75C10.8914 1.75 6.75 5.89137 6.75 11V11.75H5C4.66848 11.75 4.35054 11.8817 4.11612 12.1161C3.8817 12.3505 3.75 12.6685 3.75 13L3.75 29C3.75 29.6904 4.30964 30.25 5 30.25L27 30.25C27.6904 30.25 28.25 29.6904 28.25 29V13C28.25 12.3096 27.6904 11.75 27 11.75H25.25V11C25.25 5.89137 21.1086 1.75 16 1.75ZM22.75 11.75V11C22.75 7.27208 19.7279 4.25 16 4.25C12.2721 4.25 9.25 7.27208 9.25 11V11.75L22.75 11.75ZM6.25 14.25L6.25 27.75L25.75 27.75V14.25L6.25 14.25Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgLock);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
